import { TimeService, getMomentTz } from "@dexteel/mesf-core";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Moment } from "moment-timezone";

interface DateTimeDE {
	value: Date | null;
	format?: string;
	label?: string;
	disabled?: boolean;
	disableOpenPicker?: boolean;
	onChange: (value: Date | null) => void;
	onBlur: (value: Date | null) => void;
	error?: string;
	pause: () => void;
	resume: () => void;
}

const moment = getMomentTz();

export const DateTimePickerDE = ({
	value,
	format,
	label,
	onChange,
	onBlur,
	disabled = false,
	disableOpenPicker = false,
	error = "",
	pause,
	resume,
}: DateTimeDE) => {
	const additionalProps: { [key: string]: any } = {};
	if (format) additionalProps["format"] = format;

	const onFocus = () => {
		pause();
	};

	return (
		<DateTimePicker
			ampm={false}
			disableFuture
			disableOpenPicker={disableOpenPicker}
			disabled={disabled}
			timezone={TimeService.getInstance().getServerTimeZone()}
			label={label}
			value={moment(value)}
			onChange={(value: Moment | null) => {
				// if (value && value.isValid()) {
				onChange(value?.toDate() || null);
				// }
			}}
			slotProps={{
				textField: {
					variant: "outlined",
					fullWidth: true,
					onFocus,
					onBlur: () => {
						resume();
						onBlur(value || null);
					},
					error: !!error,
					helperText: error,
					size: "small",
					sx: {
						fontSize: "10px !important",
					},
					InputLabelProps: {
						sx: {
							fontSize: "14px",
						},
					},
					InputProps: {
						sx: {
							height: "35px",
							maxWidth: "100%",
							fontSize: "10px !important",
						},
					},
					inputProps: {
						sx: {
							fontSize: "14px !important",
						},
					},
				},
			}}
			{...additionalProps}
		/>
	);
};
